module.exports = __webpack_public_path__ + "static/media/t42.65893325.jpg";